import * as types from "./actionTypes";
import moment from 'moment';

const initialState = {
  restoring: null,
  loading: false,
  error: null,
  user: null,
  userPool: null,
  pushbackMapping: null,
  airlineCodeMapping: null,
  wsOpened: false,
  gatesData: null,
  pbRestrictionMapping: null,
  switchDataMessage: null,
  sessionInfo: null,
  tokenInfo: null,
  tokenInfoError: null,
};

const session = (state = initialState, action) => {
  switch (action.type) {
    case types.RESTORE_SESSION_REQUEST:
      return { ...state, restoring: true };
    case types.RESTORE_SESSION_SUCCESS:
      return {
        ...state,
        restoring: false,
        userPool: action.userPool,
        pushbackMapping: action.pushbackMapping,
        airlineCodeMapping: action.airlineCodeMapping
      };
    case types.RESTORE_SESSION_FAIL:
      return { ...state, restoring: false };
    case types.CLEAR_ERROR_REQUEST:
      return { ...state, error: null };
    case types.UPDATE_USER_REQUEST:
      return { ...state, user: action.user };
    case types.GET_PB_RESTRICTION:
      return {
        ...state,
        pbRestrictionMapping: action.pbRestrictionMapping
      };
        case types.GET_SESSION_INFO:
          return { ...state, loading: true, error: null, sessionInfo: null };
        case types.GET_SESSION_SUCCESS:
          const userData = {
            accessToken: {
              jwtToken: action.sessionInfo.AccessToken,
              payload: {
                auth_time: moment().unix(),
                exp: moment().add(1, 'hour').unix(),
                iat: moment().unix(),                    
                
              }
            },
            idToken: {
              jwtToken: action.sessionInfo.IdToken,
              payload: {
                auth_time: moment().unix(),
                exp: moment().add(1, 'hour').unix(),
                iat: moment().unix(),                    
                email: "",
                session_id: action.sessionInfo.session_id,
                name: action.sessionInfo.Airport_pass,
                'custom:role': "driver",
                // "cognito:username": '',
                "cognito:username": action.sessionInfo.username,
              }
            },
            refreshToken:{
              token: action.sessionInfo.RefreshToken,
            },

          };
          localStorage.setItem(
            "driverAccessToken",
            action.sessionInfo.AccessToken
          );
          localStorage.setItem(
            "driverSessionId",
            action.sessionInfo.session_id
          );

          localStorage.setItem(
            "driverAccessToken",
            action.sessionInfo.AccessToken
          );
          localStorage.setItem(
            "driverToken",
            JSON.stringify(userData)
          );
          return {
            ...state,
            loading: false,
            sessionInfo: {...action.sessionInfo, status: 'success'},
            error: null,
            user: userData,
          };

        case types.GET_SESSION_FAIL:
          return { ...state, loading: false, error: action.error, sessionInfo: { status: 'error'} };

        case types.GET_KILL_SWITCH_MESSAGE:
            return { ...state, loading: true, error: null, switchDataMessage: null };
        case types.GET_KILL_SWITCH_MESSAGE_SUCCESS:
          // console.log('switchData reducer 1',  action.switchDataMessage)
          // console.log('switchData reducer 2',  action.switchDataMessage.status)

          if (action.switchDataMessage !== 'No file found in S3 bucket') {
            localStorage.setItem(
              "switchStatus",
              action.switchDataMessage.status
            );
            
            let data = action.switchDataMessage;
            window.localStorage.setItem(
              "switchData",
              JSON.stringify(data)
            );

          } else {
            console.log('switchData off',  action.switchDataMessage)
            localStorage.setItem(
              "switchStatus",
              'OFF'
            );
          }

          return { ...state, loading: true, error: null, switchDataMessage: action.switchDataMessage };

        case types.GET_KILL_SWITCH_MESSAGE_FAIL:
          console.log('switchData fail',  action.error)
          if (action.error === 'No file found in S3 bucket') {
            // window.localStorage.removeItem("switchStatus");
            localStorage.setItem(
              "switchStatus",
              'OFF'
            );
            window.localStorage.removeItem("switchData");
          }
          return { ...state, loading: false, error: action.error, switchDataMessage: { status: 'error'} };

          case types.ENCRYPT_TOKEN_REQUEST:
            return { ...state, loading: true, tokenInfoError: null, tokenInfo: null };
          case types.ENCRYPT_TOKEN_SUCCESS:
            return {
              ...state, loading: false, tokenInfoError: null, tokenInfo: action.tokenInfo
            };
          case types.ENCRYPT_TOKEN_FAIL:
            return { ...state, loading: false, tokenInfoError: action.tokenInfoError, tokenInfo: null };
    
    default:
      return state;
  }
};

export default session;
